import React from 'react';
import { Li } from '../../layout/Ul';

const TargetAudienceList = () => (
  <React.Fragment>
    <Li>
      A developer{' '}
      <strong>
        interested in starting quickly your career as a React developer
      </strong>
      .
    </Li>
    <Li>
      You don't have to make critical decisions on your own in the React
      projects you work on.
    </Li>
    <Li>
      You are interested in intense training for extremely rapid learning by
      focusing on one thing during 3 days.
    </Li>
    <Li>
      You learn by doing. This is a hands-on project-based training - most of
      the time you'll be coding.
    </Li>
    <Li>
      You think code reviews and pair programming are useful and you are
      interested in getting feedback on your coding.
    </Li>
  </React.Fragment>
);

export default TargetAudienceList;
